import request from '@/utils/request'

import logger from '@/utils/logger'

import API from './base'

class UqudoAPI extends API {
  logUserAction(uqudoSessionId, data) {
    logger.trace('Submit lean session response', uqudoSessionId, data)

    return request({
      method: 'POST',
      trackingKey: 'risk-logging_uqudo_UQUDO-SESSION-ID_log',
      path: `/risk-logging/uqudo/${uqudoSessionId}/log`,
      data,
    })
  }

  fetchLinkStatus(uqudoSessionId) {
    logger.trace('Fetching link status', uqudoSessionId)
    return request({
      method: 'GET',
      trackingKey: 'fds_customer_leantech-connect_UQUDO-SESSION-ID_status',
      path: `/fds/customer/leantech-connect/${uqudoSessionId}/status`,
    })
  }
}
export default new UqudoAPI('/uqudo')
